import { ref, type Ref } from "vue";

export const AddressAddSucceededHappy: Ref<boolean> = ref(false)